import { render, staticRenderFns } from "./asewers-list.vue?vue&type=template&id=b8eb2d72&scoped=true&"
import script from "./asewers-list.vue?vue&type=script&lang=js&"
export * from "./asewers-list.vue?vue&type=script&lang=js&"
import style0 from "./asewers-list.vue?vue&type=style&index=0&id=b8eb2d72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8eb2d72",
  null
  
)

export default component.exports